import { FormlyFieldConfig } from "@ngx-formly/core";

export class AdminCreateCompanyForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, dataUsers, dataCompanies, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
    for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

    const users: {value: string | null, label: string}[] = [];
    for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'account_manager',
        type: 'select',
        wrappers: ['default-wrapper'],
        props: {
          required: true,
          options: users
        },
        expressions: {
          'props.label': translateService.stream('fields.account-manager')
        }
      },
      {
        key: 'parent_company',
        type: 'select',
        wrappers: ['default-wrapper'],
        props: {
          options: companies,
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.parent-company')
        }
      },
    ]
  }
}

export class AdminEditCompanyForm {
  fields: FormlyFieldConfig[];
  model: {};
  actionText = 'button.save';

  constructor(translateService, currentData, dataUsers, dataCompanies, dataAddresses, dataTemplates, user, config?) {

    const companies: {value: string | null, label: string}[] = [];
    for(const company of dataCompanies) companies.push({value: company['_id'], label: company['name'] });

    const users: {value: string | null, label: string}[] = [];
    for(const user of dataUsers) users.push({value: user['_id'], label: `${user['name']} (${user['email']})` });

    const addresses: {value: string | null, label: string}[] = [];
    for(const address of dataAddresses) addresses.push({value: address['_id'], label: address['name'] });

    const templates: {value: string | null, label: string}[] = [];
    for(const template of dataTemplates) templates.push({value: template['_id'], label: template['name'] });

    this.fields = [
      {
        key: 'name',
        type: 'input',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.name,
        props: {
          required: true,
        },
        expressions: {
          'props.label': translateService.stream('fields.name')
        }
      },
      {
        key: 'account_manager',
        type: 'select',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.account_manager._id,
        props: {
            options: users,
            required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.account-manager')
        }
      },
      {
        key: 'parent_company',
        type: 'select',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.parent_company._id,
        props: {
          options: companies,
          required: true
        },
        expressions: {
          'props.label': translateService.stream('fields.parent-company')
        }
      },
      {
        key: 'addressInvoicing',
        type: 'select',
        hide: !user.roles.includes('superadmin'),
        defaultValue: currentData.addressInvoicing,
        props: {
            options: addresses,
        },
        expressions: {
            'props.label': translateService.stream('fields.address-invoicing')
        }
      },
      {
        key: 'addressShipping',
        type: 'select',
        hide: !user.roles.includes('superadmin'),
        defaultValue: currentData.addressShipping,
        props: {
            options: addresses,
            multiple: true,
        },
        expressions: {
            'props.label': translateService.stream('fields.address-shipping')
        }
      },
      {
        key: 'isDistributor',
        type: 'checkbox',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.isDistributor ?? false,
        expressions: {
          'props.label': translateService.stream('billing.distributor.isDistributor')
        }
      },
      {
        key: 'defaultBillingTemplateId',
        type: 'select',
        wrappers: ['default-wrapper'],
        defaultValue: currentData.defaultBillingTemplateId,
        props: {
          options: templates,
        },
        expressions: {
          'props.label': translateService.stream('fields.default-billing-template'),
          'hide': (field) => !field.model.isDistributor,
        }
      },
]
  }
}